import Alpine from 'alpinejs'
// import Splide from '@splidejs/splide'
import focus from '@alpinejs/focus'

// Components
Alpine.plugin(focus)

// Global
window.Alpine = Alpine
// window.Splide = Splide

// Inits
Alpine.start()
